// extracted by mini-css-extract-plugin
export default {"maincontainer":"EdpDashboard_maincontainer__8ECvn","background":"EdpDashboard_background__L83df","loader":"EdpDashboard_loader__7iNgT"};